import { getFundraiser } from 'actions/app'
import routes from 'config/routes'
import * as Pages from 'pages'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { Route, Switch, useParams } from 'react-router-dom'

function App({ getFundraiser }) {
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState(false)
  const { shortcode } = useParams()

  React.useEffect(() => {
    const load = async () => {
      try {
        await getFundraiser(shortcode)
      } catch (err) {
        setError(true)
        console.error('Unable to load fundraiser')
        console.error(err)
      } finally {
        setLoading(false)
      }
    }

    load()
  }, [getFundraiser, shortcode])

  if (loading) {
    return <Pages.Loading />
  }

  if (error) {
    return <div>An error occurred</div>
  }

  return (
    <Switch>
      <Route exact path={routes.leaderboard} component={Pages.Leaderboard} />
      <Route component={Pages.Support} />
    </Switch>
  )
}

App.propTypes = {
  getFundraiser: PropTypes.func.isRequired,
}

const mapDispatch = {
  getFundraiser,
}

export default connect(null, mapDispatch)(App)
